export default {
  name: 'PendingTag',
  props: {
    tag: {
      type: Object,
      required: true
    }
  },
  mounted() {
    if (document.readyState === 'complete') {
      this.$root.$emit('generic-tracking', null, this.tag);
    } else {
      window.mdm_events_pending = window.mdm_events_pending || [];
      window.mdm_events_pending.push({
        event: null,
        data: this.tag
      });
    }
  },
  render: h => h(null)
};